import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import { Wifi, LayoutDashboard, Smartphone, Cable, LogOut } from "lucide-react";
import { useEffect } from "react";
import { useCustomerAuth } from "@/context/CustomerAuthContext";

export default function CustomerLayout() {
  const { customer, checking, logout } = useCustomerAuth();
  const nav = useNavigate();
  const loc = useLocation();

  useEffect(() => {
    if (!checking && !customer) nav("/customer/login", { replace: true });
  }, [checking, customer, nav]);

  if (checking || !customer) return null;

  const tabs = [
    { to: "/customer/dashboard", icon: LayoutDashboard, label: "Overview", id: "customer-nav-overview" },
    { to: "/customer/devices", icon: Smartphone, label: "Devices", id: "customer-nav-devices" },
    { to: "/customer/pppoe", icon: Cable, label: "PPPoE", id: "customer-nav-pppoe" },
  ];

  return (
    <div className="min-h-screen bg-[#F7F7F5] text-[#1A1C20]">
      <header className="border-b border-[#E1E4E8] bg-white">
        <div className="max-w-5xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2">
            <div className="h-8 w-8 grid place-items-center bg-[#43B02A] rounded-full">
              <Wifi className="h-4 w-4 text-white" strokeWidth={2.5} />
            </div>
            <div>
              <div className="font-heading font-black text-sm leading-none">NetOnLain</div>
              <div className="font-mono text-[9px] uppercase tracking-[0.2em] text-[#57606A] mt-1">My account</div>
            </div>
          </Link>
          <div className="flex items-center gap-4">
            <div className="text-right">
              <div className="text-xs text-[#57606A] font-mono">Signed in as</div>
              <div className="text-sm font-mono font-bold" data-testid="customer-phone-display">{customer.phone}</div>
            </div>
            <button
              data-testid="customer-logout-btn"
              onClick={async () => { await logout(); nav("/customer/login"); }}
              className="h-9 px-3 rounded-full border border-[#E1E4E8] hover:border-[#43B02A] hover:text-[#43B02A] flex items-center gap-1.5 text-xs font-mono uppercase tracking-[0.15em]"
            ><LogOut className="h-3.5 w-3.5" /> Sign out</button>
          </div>
        </div>
        <nav className="max-w-5xl mx-auto px-6 -mb-px flex gap-1">
          {tabs.map((t) => {
            const active = loc.pathname.startsWith(t.to);
            return (
              <Link key={t.to} to={t.to} data-testid={t.id}
                    className={`h-11 flex items-center gap-2 px-4 border-b-2 font-mono uppercase tracking-[0.15em] text-xs ${
                      active ? "border-[#43B02A] text-[#43B02A]" : "border-transparent text-[#57606A] hover:text-[#1A1C20]"
                    }`}>
                <t.icon className="h-3.5 w-3.5" /> {t.label}
              </Link>
            );
          })}
        </nav>
      </header>
      <main className="max-w-5xl mx-auto px-6 py-8"><Outlet /></main>
    </div>
  );
}
